import { Decimal } from '@snap-types/types/decimal';

/**
 * Converts a percentage to a decimal.
 *
 * @remarks
 * Decimals do not maintain trailing zeroes. For example, converting 50% to a decimal
 * will result in 0.5, not 0.5000. To render a decimal with trailing zeroes, you can
 * use `toFixed` with the number of decimal places you want to display.
 */
export function percentToDecimal(percent: Decimal, decimalPlaces = 4): Decimal {
  return percent.dividedBy(100).toDecimalPlaces(decimalPlaces);
}

/**
 * Converts a decimal to a percent string.
 *
 * @remarks
 * We don't do math on percents, so we return the value as a string. We reduce the number
 * of decimal places by 2 to account for the fact that we're multiplying by 100 and want
 * to maintain the same precision if we were to convert back to a decimal.
 */
export function decimalToPercent(decimal: Decimal, decimalPlaces = 4): string {
  if (decimalPlaces < 2) {
    return decimal.times(100).toFixed(0);
  }

  return decimal.times(100).toFixed(decimalPlaces - 2);
}
